import React from 'react'

export default function About() {
  return (
    <div><h1>Hello word</h1></div>
  )
}
